module.exports = __webpack_public_path__ + "img/square-table-12.9b8d3bcf.png";